import React from "react";

export const InstantFormContext = React.createContext({
    setSKUSChildsContext: null,
    removeSKUSChildsContext: null,
    formData: null,
    isEdit: null,
});